import { TRANSLATIONS } from '../../config/translations';

/**
 * Date range filter with preset buttons (Last 30/90 days) and custom range
 */
export function DateRangeFilter({ startDate, endDate, onStartDateChange, onEndDateChange, language }) {
  const t = TRANSLATIONS[language] || TRANSLATIONS.de;

  // Calculate date for "Last X days" presets
  const getDateXDaysAgo = (days) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date.toISOString().split('T')[0];
  };

  const getTodayDate = () => {
    return new Date().toISOString().split('T')[0];
  };

  const handlePreset = (days) => {
    onStartDateChange(getDateXDaysAgo(days));
    onEndDateChange(getTodayDate());
  };

  return (
    <div className="date-range-filter">
      <div className="date-range-presets">
        <button
          type="button"
          className="btn-preset"
          onClick={() => handlePreset(30)}
        >
          {t.last30Days}
        </button>
        <button
          type="button"
          className="btn-preset"
          onClick={() => handlePreset(90)}
        >
          {t.last90Days}
        </button>
      </div>

      <div className="date-range-inputs">
        <div className="form-group">
          <label>{t.startDate}</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            max={endDate || getTodayDate()}
          />
        </div>

        <div className="form-group">
          <label>{t.endDate}</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            min={startDate}
            max={getTodayDate()}
          />
        </div>
      </div>
    </div>
  );
}
